import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

export default class extends Controller {
  static targets = ["canvas", "data"]

  connect() {
    const pieSprintChart = this.canvasTarget

    const labels = this.dataTargets.map(el => el.dataset.label)
    const backgroundColor = this.dataTargets.map(el => el.dataset.color)
    const count = this.dataTargets.map(el => el.dataset.count)

    const data = {
      labels,
      datasets: [{
        data: count,
        backgroundColor,
        borderWidth: 0,
        hoverOffset: 2
      }]
    }

    this.chart = new Chart(pieSprintChart, {
      type: "doughnut",
      data,
      options: {
        cutoutPercentage: 84,
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend: {
            display: false
          },
        }
      },
    })
  }
}
